/**
* DevExpress Dashboard (_format-condition-range-gradient.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { formatConditionRangeBaseSerializationsInfo } from './_format-condition-range-base';
export let segmentNumber = { propertyName: 'segmentNumber', displayName: 'DashboardWebStringId.ConditionalFormatting.SegmentNumber', defaultVal: 10, simpleFormAdapterItem: 'numberBoxEditor' };
export let formatConditionRangeGradientSerializationsInfo = formatConditionRangeBaseSerializationsInfo.concat([]);
